{
    "date": "02/08/2022",
    "versionId": "6",
    "version": "0.0.6",
    "description": "hhhhhhhh I'm too lazy to add a full description for this update, but who cares anyways?",
    "changes": [
        {
            "title": "⚙️ Introducing: Settings!",
            "description": "Check out the settings page by right clicking anywhere on the screen!"
        },
        {
            "title": "🌟 New Context Menu",
            "description": "Did you know that mouses had two buttons? Well I sure didn't!\nNow you can right click anything to get context-specific options!"
        },
        {
            "title": "🖌️ Colors are cool!",
            "description": "Some random guy told me \"Okay but what if you add customizable color schemes?\" and I was like \"shi now we talkin\""
        },
        {
            "title": "🌚 Dark mode",
            "description": "For all the night owls out there, we finally implemented a dark mode!"
        }
    ]
}